import { createStyles } from '@mantine/core';
import { getTypographyStyles } from 'src/theme/themeConfig';

export const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    contentContainer: {
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      paddingTop: '0',
    },
    optionContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      justifyContent: 'space-between',
    },
    formWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      '& .mantine-Select-input, .mantine-FileInput-input': {
        borderRadius: '4px',
        height: '44px',
        border: `1px solid ${colors.disabled.muted}`,
        backgroundColor: colors.bg.default,
        ...getTypographyStyles('content_sm_regular'),
        '&[data-with-icon]': {
          paddingLeft: '48px',
        },
      },
      '& .mantine-Select-item': {
        border: 'none',
        width: '100%',
        padding: '12px 24px',
        ...getTypographyStyles('content_sm_regular'),
      },
      '& .mantine-FileInput-icon': {
        marginLeft: '6px',
        color: colors.fg.default,
      },
    },

    bottomPageLink: {
      color: '#1DBBF0',
      border: 'none',
      padding: '0px',
      backgroundColor: 'transparent',
      outline: 'none',
      width: 'auto',
      textAlign: 'left',
    },
    fileInputWrapper: {
      border: `1px solid ${theme.other.colors.primaryOld}`,
      borderRadius: '8px',
      background: theme.colors.magenta[9],
      padding: 'auto',
    },
    fileInputPlaceholder: {
      color: theme.colors.blue[4],
    },
    backButtonWrapper: {
      position: 'absolute',
      top: 16,
      left: 16,
      zIndex: 99,
    },
    changeNumberLink: {
      color: '#1DBBF0',
      fontSize: '16px',
      fontWeight: 500,
      border: 'none',
      backgroundColor: 'transparent',
      outline: 'none',
      textAlign: 'left',
      paddingLeft: '4px',
      margin: '24px 0px',
      '&:disabled': {
        color: '#8c8c8c',
      },
    },
    skipBtn: {
      margin: '0px',
    },
    checkLabel: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '8px',
      '& input': {
        marginTop: '2px',
      },
    },
    checkbox: {
      cursor: 'pointer',
      accentColor: colors.primary.default,
    },
    inputDescription: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
    },
    terms: {
      color: colors.fg.muted,
      marginTop: '0px',
    },
    // Setu Flow
    setuContentContainer: {
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      paddingTop: '0',
    },
    setCtaWrapper: {
      display: 'flex',
      backgroundColor: colors.primary.muted,
      padding: '16px 24px',
      borderRadius: '8px',
    },
    setuFooter: {
      justifyContent: 'flex-start !important',
    },
    setuFlowButton: {
      all: 'unset',
      cursor: 'pointer',
      ...getTypographyStyles('content_xs_regular'),

      '&:hover': {
        color: colors.primary.default,
      },
    },
    changeSetuFlow: {
      marginTop: 'auto',
    },
  };
});

export default {};
